export default ({ request }) => ({
  // 获取租户列表
  get_tenants_list(params) {
    return request({
      url: '/v1/tenants/list',
      method: 'get',
      params: params
    })
  },

  // 获取租户详情
  get_tenant_detail(id) {
    return request({
      url: `/v1/tenants/${id}`,
      method: 'get'
    })
  },

  // 创建租户
  create_tenant(data) {
    return request({
      url: '/v1/tenants',
      method: 'post',
      data: data
    })
  },

  // 更新租户
  update_tenant(id, data) {
    return request({
      url: `/v1/tenants/${id}`,
      method: 'put',
      data: data
    })
  },

  // 删除租户
  delete_tenant(id) {
    return request({
      url: `/v1/tenants/${id}`,
      method: 'delete'
    })
  },

  // 设置租户可用权限
  set_tenant_permissions(id, data) {
    return request({
      url: `/v1/tenants/${id}/permissions`,
      method: 'put',
      data: data
    })
  },

  // 获取租户可用权限
  get_tenant_permissions(id) {
    return request({
      url: `/v1/tenants/${id}/permissions`,
      method: 'get'
    })
  },

  // 为租户分配用户
  assign_user_to_tenant(data) {
    return request({
      url: '/v1/tenants/assign_user_to_tenant',
      method: 'post',
      data: data
    })
  },

  // 获取所有租户的统计信息（超管首页专用）
  get_dashboard_stats() {
    return request({
      url: '/v1/tenants/dashboard/stats',
      method: 'get'
    })
  },

  // 同步租户数据库表结构
  sync_tenant_schema(id) {
    return request({
      url: `/v1/tenants/${id}/sync-schema`,
      method: 'post'
    })
  }
})
